// extracted by mini-css-extract-plugin
module.exports = {"Review":"Review_Review__3DOKb","userInfo":"Review_userInfo__3xfHR"};